import React, {useEffect, useState} from 'react';

import {Button, Input, Space, Table} from "antd";
import {ArrowUpDown, FilterIcon, SearchIcon} from "lucide-react";
import {useApiSearchAdminPolls} from "@/api/poll";

function AdminPollListPage(props) {

    const [searchText, setSearchText] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const {
        data,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
        refetch
    } = useApiSearchAdminPolls(
        {},
        {enabled: true}
    );


    useEffect(() => {
        setFilteredData(data)
    }, []);
    const handleSearch = (value) => {
        const searchLower = value.toLowerCase();
        const filtered = data.filter((item) =>
            Object.values(item).some(
                (val) => typeof val === 'string' && val.toLowerCase().includes(searchLower)
            )
        );
        setFilteredData(filtered);
        setSearchText(value);
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: 'Age',
            dataIndex: 'age',
            key: 'age',
            sorter: (a, b) => a.age - b.age,
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            sorter: (a, b) => a.address.localeCompare(b.address),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: (a, b) => a.email.localeCompare(b.email),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            filters: [
                {text: 'Active', value: 'active'},
                {text: 'Inactive', value: 'inactive'},
            ],
            onFilter: (value, record) => record.status === value,
            render: (status) => (
                <span
                    className={`px-2 py-1 rounded-full text-sm ${
                        status === 'active'
                            ? 'bg-green-100 text-green-800'
                            : 'bg-red-100 text-red-800'
                    }`}
                >
          {status}
        </span>
            ),
        },
    ];

    const onChange = (
        pagination,
        filters,
        sorter,
        extra
    ) => {

    };

    return (
        <div className="min-h-screen">

            <div className="bg-white rounded-lg shadow-sm p-6">
                <div className="mb-6">

                    <Space className="mb-4">
                        <Input
                            placeholder="Search..."
                            value={searchText}
                            onChange={(e) => handleSearch(e.target.value)}
                            prefix={<SearchIcon className="h-4 w-4 text-gray-400"/>}
                            className="w-64"
                        />
                        <Button
                            icon={<FilterIcon className="h-4 w-4"/>}
                            className="flex items-center"
                        >
                            Filters
                        </Button>
                        <Button
                            icon={<ArrowUpDown className="h-4 w-4"/>}
                            className="flex items-center"
                        >
                            Sort
                        </Button>
                    </Space>
                </div>
                <Table
                    columns={columns}
                    size={'small'}
                    dataSource={filteredData}
                    onChange={onChange}
                    pagination={{
                        total: filteredData?.length,
                        pageSize: 10,
                        showSizeChanger: true,
                        showQuickJumper: true,
                    }}
                />

            </div>
        </div>
    );
}

export default AdminPollListPage;


